import React, { useState, useEffect } from "react";
import {
  FaCircle,
  FaCheckCircle,
  FaPauseCircle,
  FaTimesCircle,
} from "react-icons/fa";
import Getuser from "../../Services/Getuser";

const OnlineDrivers = () => {
  const [selectedButton, setSelectedButton] = useState("All");
  const [onlineDrivers, setOnlineDrivers] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // Function to fetch drivers based on the selected status
  const fetchActiveDrivers = async (status) => {
    try {
      const data = await Getuser.fetchActiveDrivers(status);
      setOnlineDrivers(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error fetching active users:", error);
    }
  };

  // Effect to fetch drivers when the component mounts or when selectedButton changes
  useEffect(() => {
    const statusMap = {
      All: "ALL", // Assuming you want to fetch all drivers when "All" is selected
      Online: "ONLINE",
      Busy: "BUSY",
      Idle: "IDLE",
      Offline: "OFFLINE",
    };

    const status = statusMap[selectedButton];
    fetchActiveDrivers(status);
  }, [selectedButton]);

  const handleButtonClick = (buttonName) => {
    setSelectedButton(buttonName);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Function to get the icon based on the driver's status
  const getStatusIcon = (status) => {
    switch (status) {
      case "ONLINE":
        return <FaCheckCircle className="text-green-500" title="Online" />;
      case "BUSY":
        return <FaPauseCircle className="text-yellow-500" title="Busy" />;
      case "IDLE":
        return <FaCircle className="text-blue-500" title="Idle" />;
      case "OFFLINE":
        return <FaTimesCircle className="text-red-500" title="Offline" />;
      default:
        return null;
    }
  };

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <h2 className="text-2xl font-bold">Active Drivers</h2>
        </div>

        <div className="card">
          <div className="card-body">
            {/* Filter Buttons */}
            <div
              className="d-flex flex-row gap-2 mb-4"
              style={{ maxWidth: "30%" }}
            >
              {["All", "Online", "Busy", "Idle", "Offline"].map((label) => (
                <button
                  key={label}
                  type="button"
                  className={`btn ml-4 ${
                    selectedButton === label
                      ? "btn-primary text-white"
                      : "btn-outline-primary"
                  }`}
                  onClick={() => handleButtonClick(label)}
                >
                  {label}
                </button>
              ))}
            </div>

            {/* Online Drivers Table */}
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Phone Number</th>
                  <th>Email</th>
                  <th>Status</th>
                  <th>Ratings</th>
                  <th>Total Earnings</th>
                  <th>Wallet Balance</th>
                </tr>
              </thead>
              <tbody>
                {onlineDrivers.map((driver) => (
                  <tr key={driver.id}>
                    <td>{driver.id}</td>
                    <td>{driver.name}</td>
                    <td>{driver.phone_number}</td>
                    <td>{driver.email}</td>
                    <td>{getStatusIcon(driver.status)}</td>
                    <td>{driver.ratings}</td>
                    <td>{driver.totalEarning}</td>
                    <td>{driver.wallet_balance}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="card-footer clearfix">
            <ul className="pagination pagination-sm m-0 float-right">
              <li className="page-item">
                <a
                  className="page-link"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    if (currentPage > 1) handlePageChange(currentPage - 1);
                  }}
                >
                  &laquo;
                </a>
              </li>
              {[...Array(totalPages).keys()].map((page) => (
                <li
                  className={`page-item ${
                    currentPage === page + 1 ? "active" : ""
                  }`}
                  key={page + 1}
                >
                  <a
                    className="page-link"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handlePageChange(page + 1);
                    }}
                  >
                    {page + 1}
                  </a>
                </li>
              ))}
              <li className="page-item">
                <a
                  className="page-link"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    if (currentPage < totalPages)
                      handlePageChange(currentPage + 1);
                  }}
                >
                  &raquo;
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnlineDrivers;
